import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaModalOverlayRef } from '@global-front-components/ui/modal-overlay';

@Component({
	standalone: true,
	imports: [
		CommonModule
	],
	templateUrl: './modal-informacion.component.html',
	styleUrls: ['./modal-informacion.component.scss']
})
export class ModalInformacionComponent implements OnInit {
	@Input() data!: any;
	textoInfo: string;
	urlImagen: string;

	constructor(
		private _modalRef: CaModalOverlayRef<ModalInformacionComponent>,
	) { }

	ngOnInit(): void {
		this.textoInfo = this.data?.textoInfo;
		const urlRecibida = this.data?.urlImagen;

		if (urlRecibida && !urlRecibida.startsWith('http')) {
			this.urlImagen = `/assets/images${urlRecibida}`;;			
		} else {
			this.urlImagen = urlRecibida;
		}
	}

	closeDialog(text?: string): void {
		if (text) {
			this._modalRef.close(text);
		} else {
			this._modalRef.close();
		}
	}
}
